import { ButtonIcon, MenuContent, MenuRoot, MenuTrigger } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

type MoreActionsProps = {
  children: React.ReactNode;
};

export const ChatMessageMoreActionsMenu = ({ children }: MoreActionsProps) => {
  return (
    <MenuRoot placement="top-end" offset={[-10, 0]} autoSelect={false}>
      <MenuTrigger asChild>
        <ButtonIcon
          minW={8}
          h={8}
          _focusVisible={{
            outline: 'none',
          }}
          aria-label="more options"
          variant="ghost"
        >
          <Icon name={iconNames.dotsHoriz} fill="var(--fgSecondary)" />
        </ButtonIcon>
      </MenuTrigger>
      <MenuContent w="10rem" p="0" overflow="hidden">
        {children}
      </MenuContent>
    </MenuRoot>
  );
};
